<template>
	<div class="head"  el-table v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 1, 39, 0.8)">
		<div >
			<el-container>
				<el-header height='160px'>
					<div class="upper">
						<el-row>
							<el-col :span="12">
								<div class="time">
									{{ nowTime }} 星期{{ week | getweek }}
								</div>
							</el-col>
							<el-col :span="12">
								<div class="button">
									<el-row>
										<el-row>
											<el-col :span="8">
												<!-- <div style="width: 100px;text-align: center;">
													<img src="../assets/home.png" />
												</div> -->
											</el-col>
											<el-col :span="8">
												<!-- <div style="width: 100px;text-align: center;">
													<img src="../assets/screen.png" />
												</div> -->
											</el-col>
											<el-col :span="8">
												<div style="width: 100px;text-align: center;" @click="returns()">
													<img src="../assets/return.png" />
												</div>
											</el-col>
										</el-row>
									</el-row>
								</div>
							</el-col>
						</el-row>
					</div>
					<div class="boxdow">
						<div id="main" style="width: 100%;height:840px;" />
					</div>
				</el-header>

			</el-container>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	import * as echarts from 'echarts';
	import axios from 'axios';
	import {
		getport
	} from '@/api/api'
	export default {
		data() {
			return {
				nowTime:'',
				week:'',
				loading: true,
				listdata: [{
					tit: [],
					siz: [],
				}, {
					tita: [],
					siza: [],
				}, {
					titb: [],
					sizb: [],
				}, {
					titc: [],
					sizc: [],
				}, {
					titd: [],
					sizd: [],
				}, {
					tite: [],
					size: [],
				}, ]
			}
		},
		created() {
			this.gethmss()
			this.getCurrentTime()
		},
		filters: {
			getweek(e) {
				var week = ['一', '二', '三', '四', '五', '六', '日']
				return week[e - 1]
			},
		},
		mounted() {
			
		},
		methods: {
			getCurrentTime() {
				this.nowTime = moment().format('YYYY年MM月DD日')
				this.week = moment().format('E')
			},
			gethmss() {
				let path = '?id=6'
				getport('', path).then(res => {
					this.listdata[0].tit = JSON.parse('[' + res.data[0][0] + ']')
					this.listdata[0].siz = JSON.parse('[' + res.data[1] + ']')
					this.listdata[1].tita = JSON.parse('[' + res.data[2][0] + ']')
					this.listdata[1].siza = JSON.parse('[' + res.data[3] + ']')
					this.listdata[2].titb = JSON.parse('[' + res.data[4][0] + ']')
					this.listdata[2].sizb = JSON.parse('[' + res.data[5] + ']')
					this.listdata[3].titc = JSON.parse('[' + res.data[6][0] + ']')
					this.listdata[3].sizc = JSON.parse('[' + res.data[7] + ']')
					this.listdata[4].titd = JSON.parse('[' + res.data[8][0] + ']')
					this.listdata[4].sizd = JSON.parse('[' + res.data[9] + ']')
					this.listdata[5].tite = JSON.parse('[' + res.data[10][0] + ']')
					this.listdata[5].size = JSON.parse('[' + res.data[11] + ']')
					console.log(this.listdata)
					console.log(res)
					this.loading = false
					this.myEcharts()
				})
			},
			returns() {
				this.$router.replace({
					path: '/'
				});
			},
			//echats配置
			myEcharts() {
				
					
					var myChart = echarts.init(document.getElementById('main'));
					// 绘制柱状图表
					myChart.setOption({
						color: ['#dc3168', '#2db7f9', '#df9d0c', '#00fffc', '#001efe', '#ea01fe'],
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'cross',
								label: {
									backgroundColor: '#6a7985'
								}
							}
						},
						legend: {
							textStyle: {
								fontSize: 16, //字体大小
								color: '#5192c3' //字体颜色
							},
							data: ['联系一个村或重点项目', '接待一次选民', '提出一条建议', '参加一次调研', '解决一个实际问题', '接受一次述职评议']
						},
						grid: {
							left: '0%',
							right: '2%',
							bottom: '3%',
							containLabel: true
						},
						xAxis: [{
								type: 'category',
								boundaryGap: false,
								data: ['鲍沟代表团', '滨湖代表团', '柴胡店代表团', '东郭代表团', '大坞代表团', '官桥代表团', '洪绪代表团',
									'界河代表团',
									'级索代表团', '姜屯代表团', '龙阳代表团', '木石代表团', '南沙河代表团', '西岗代表团', '羊庄代表团',
									'张汪代表团',
									'北辛代表团', '东沙河代表团', '荆和代表团', '龙泉代表团', '善南代表团', '机关代表团', '工信代表团'
								],
								axisLine: {
									show: false
								},
								axisTick: {
									show: false
								},
								axisLabel: {
									show: true,
									color: '#ffffff',
									fontSize: 15,
									interval: 0,
									width: 30,
									overflow: "breakAll"
								},
								splitLine: {
									show: true,
									lineStyle: {
										type: 'dashed', //默认实线，dashed虚线
										width: 1,
										color: '#4BDFFF',
									}
								},
							}

						],
						yAxis: {
							// min: 50, // 坐标轴刻度最小值
							max: 50, // 坐标轴刻度最大值
							interval: 5, // 强制设置坐标轴分割间隔
							axisLabel: {
								show: true,
								color: '#ffffff',
								fontSize: 12,
							},
							type: 'value',
							axisLine: {
								show: false
							},
							axisTick: {
								show: false
							},
							splitLine: {
								show: true,
								lineStyle: {
									// type: 'dashed', //默认实线，dashed虚线
									width: 1,
									color: '#17273D',
								}
							},
						},
						series: [{
								itemStyle: {
									normal: {
										lineStyle: { //折线图连线的设置
											color: '#dc3168',
											width: 1 //设置线条粗细
										}
									}
								},
								name: '联系一个村或重点项目',
								type: 'line',
								stack: 'Total',
								smooth: true,
								lineStyle: {
									width: 0
								},
								showSymbol: true,
								type: 'line',
								areaStyle: {
									color: {
										//线性渐变 	
										type: 'linear',
										x: 0,
										y: 0,
										x2: 0,
										y2: 1,
										colorStops: [{
											offset: 0,
											color: '#dc3168', // 0% 处的颜色
										}, {
											offset: 0.4,
											color: 'rgba(220, 49, 104, 0.0)', // 100% 处的颜色
										}],
										global: false, // 缺省为 false
									},
								},
								emphasis: {
									focus: 'series'
								},
								data: this.listdata[0].siz
							},

							{
								itemStyle: {
									normal: {
										lineStyle: { //折线图连线的设置
											color: '#2eb6fa',
											width: 1 //设置线条粗细
										}
									}
								},
								name: '接待一次选民',
								type: 'line',
								// stack: 'Total',
								smooth: true,
								lineStyle: {
									width: 0
								},
								showSymbol: true,
								type: 'line',
								areaStyle: {
									color: {
										//线性渐变 	
										type: 'linear',
										x: 0,
										y: 0,
										x2: 0,
										y2: 1,
										colorStops: [{
											offset: 0,
											color: '#2eb6fa', // 0% 处的颜色
										}, {
											offset: 0.4,
											color: 'rgba(46, 182, 250, 0.0)', // 100% 处的颜色
										}],
										global: false, // 缺省为 false
									},
								},
								emphasis: {
									focus: 'series'
								},
								data: this.listdata[1].siza
							},


							{
								itemStyle: {
									normal: {
										lineStyle: { //折线图连线的设置
											color: '#dd9e0d',
											width: 1 //设置线条粗细
										}
									}
								},
								name: '提出一条建议',
								type: 'line',
								// stack: 'Total',
								smooth: true,
								lineStyle: {
									width: 0
								},
								showSymbol: true,
								type: 'line',
								areaStyle: {
									color: {
										//线性渐变 	
										type: 'linear',
										x: 0,
										y: 0,
										x2: 0,
										y2: 1,
										colorStops: [{
											offset: 0,
											color: 'rgba(221, 158, 13, 0.8)', // 0% 处的颜色
										}, {
											offset: 0.4,
											color: 'rgba(221, 158, 13, 0.0)', // 100% 处的颜色
										}],
										global: false, // 缺省为 false
									},
								},
								emphasis: {
									focus: 'series'
								},
								data: this.listdata[2].sizb
							},



							{
								itemStyle: {
									normal: {
										lineStyle: { //折线图连线的设置
											color: '#00fefb',
											width: 1 //设置线条粗细
										}
									}
								},
								name: '参加一次调研',
								type: 'line',
								// stack: 'Total',
								smooth: true,
								lineStyle: {
									width: 0
								},
								showSymbol: true,
								type: 'line',
								areaStyle: {
									color: {
										//线性渐变 	
										type: 'linear',
										x: 0,
										y: 0,
										x2: 0,
										y2: 1,
										colorStops: [{
											offset: 0,
											color: 'rgba(0, 254, 251, 0.8)', // 0% 处的颜色
										}, {
											offset: 0.4,
											color: 'rgba(0, 254, 251, 0.0)', // 100% 处的颜色
										}],
										global: false, // 缺省为 false
									},
								},
								emphasis: {
									focus: 'series'
								},
								data: this.listdata[3].sizc
							},



							{
								itemStyle: {
									normal: {
										lineStyle: { //折线图连线的设置
											color: '#001eff',
											width: 1 //设置线条粗细
										}
									}
								},
								name: '解决一个实际问题',
								type: 'line',
								// stack: 'Total',
								smooth: true,
								lineStyle: {
									width: 0
								},
								showSymbol: true,
								type: 'line',
								areaStyle: {
									color: {
										//线性渐变 	
										type: 'linear',
										x: 0,
										y: 0,
										x2: 0,
										y2: 1,
										colorStops: [{
											offset: 0,
											color: 'rgba(0, 30, 255, 0.8)', // 0% 处的颜色
										}, {
											offset: 0.4,
											color: 'rgba(0, 30, 255, 0.0)', // 100% 处的颜色
										}],
										global: false, // 缺省为 false
									},
								},
								emphasis: {
									focus: 'series'
								},
								data: this.listdata[4].sizd
							},




							{
								itemStyle: {
									normal: {
										lineStyle: { //折线图连线的设置
											color: '#ea01fe',
											width: 1 //设置线条粗细
										}
									}
								},
								name: '接受一次述职评议',
								type: 'line',
								// stack: 'Total',
								smooth: true,
								lineStyle: {
									width: 0
								},
								showSymbol: true,
								type: 'line',
								areaStyle: {
									color: {
										//线性渐变 	
										type: 'linear',
										x: 0,
										y: 0,
										x2: 0,
										y2: 1,
										colorStops: [{
											offset: 0,
											color: 'rgba(234, 1, 254, 0.8)', // 0% 处的颜色
										}, {
											offset: 0.4,
											color: 'rgba(234, 1, 254, 0.0)', // 100% 处的颜色
										}],
										global: false, // 缺省为 false
									},
								},
								emphasis: {
									focus: 'series'
								},
								data: this.listdata[5].size
							},



						]
					})


				

			},
		}
	}
</script>

<style scoped>
	.head{
		width: 1920px;
		height: 1080px;
		display: flex;
		margin: 0px auto;
		position: relative;
		justify-content: center;
		background-color: #000127;
	}
	.upper {
		width: 1835px;
		padding: 30px 0 0 0;
		position: relative;
		background-size: contain;
		height: 160px !important;
		/* border: 1px solid red; */
		background: url('../assets/tieliepng.png') no-repeat center;
	}

	.time {
		width: 40%;
		height: 40px;
		color: #ffffff;
		font-size: 20px;
		margin-left: 5%;
		margin-top: 50px;
		line-height: 40px;
		/* border: 1px solid #aa0000; */
	}

	.button {
		width: 40%;
		height: 40px;
		color: #ffffff;
		font-size: 20px;
		margin-top: 70px;
		margin-left: 55%;
		line-height: 40px;
		display: flex;
		justify-content: center;
	}

	.boxdow {
		width: 100%;
		height: 840px;
		/* border: 1px solid #aa0000; */
	}

	/* 1,滚动条 */
	::-webkit-scrollbar {
		width: 5px;
		/* 纵向滚动条 宽度 */
		height: 15px;
		/* 横向滚动条 高度 */
		background: #62C2FF;
		/* 整体背景 */
		border-radius: 10px;
		/* 整体 圆角 */
	}

	/* 4.内层轨道，它会覆盖外层轨道的样式。 */
	::-webkit-scrollbar-track-piece {
		width: 5px;
		background-color: #ffffff;
		margin: 0 -2px 0;
		border-radius: 10px;
	}

	/* 5,滑块 */
	::-webkit-scrollbar-thumb {
		background: #62C2FF;
		min-height: 0px;
		min-width: 50px;
		border-radius: 10px;
	}


	/* tmd嗯改样式 */
	/deep/.row-item {
		border-bottom: 1px dashed #5AE9FF !important;
		font-size: 16px !important;
	}

	/deep/.dv-scroll-board {
		color: #b1b1b1 !important;
	}
</style>
<!-- <style>
	body {
		width: 1920px;
		height: 1080px;
		display: flex;
		margin: 0px auto;
		position: relative;
		justify-content: center;
		background-color: #000128;
	}
</style> -->